import * as React from "react";
import { LoadingSpinner } from "@app/shared";
import { QESAlert, QESMultiSelect } from "@app/shared/qes-standards";
import { InsurancesContext } from "@app/admin/contexts/InsurancesContext";
import { ClientContext } from "../../contexts/ClientContext";
import { MultiselectItem, MultiselectOnChangeResponse } from "../../../shared/qes-standards/forms/Multiselect";
import { CheckboxStateEnum } from "../../../shared/qes-standards/forms/Checkbox";

interface ClientInsurancesProps {
  disabled?: boolean;
}

export const ClientAuthorizedInsurances: React.FC<React.PropsWithChildren<ClientInsurancesProps>> = (props: ClientInsurancesProps) => {
  const clientContext = React.useContext(ClientContext);
  const insurancesList = React.useContext(InsurancesContext).availableInsurances;

  const selectedOptions = React.useMemo(() => clientContext.authorizedInsurances.map((i) => i.uid).sort(), [clientContext.authorizedInsurances]);

  const insuranceOptions: { [key: string]: MultiselectItem } = React.useMemo(() => {
    const insuranceObj = {};
    insurancesList.forEach((i) => Object.assign(insuranceObj,
      {
        [i.uid]: {
          currentState: selectedOptions.includes(i.uid) ? CheckboxStateEnum.Checked : CheckboxStateEnum.Unchecked,
          displayValue: i.planName + ": " + i.uid,
        }
      }));
    return insuranceObj;
  }, [insurancesList, selectedOptions]);


  const updateInsurances = (response: MultiselectOnChangeResponse) => {
    const selectedInsurances = response.checkedKeys;
    const newInsurances = selectedInsurances.map((uid) => {
      const matchedInsurances = insurancesList.find((i) => i.uid === uid);
      return matchedInsurances;
    });
    clientContext.setAuthorizedInsurances(newInsurances.map(i => ({ planName: i.planName, uid: i.uid })));
  }

  return (
    <>
      {(clientContext.availableInsurancesIsLoading || clientContext.authorizedInsurancesIsLoading) && (
        <div className="col-12">
          <LoadingSpinner />
        </div>
      )}

      {clientContext.insurancesHaveErred && (
        <QESAlert type="danger" persist={true}>Unable to load accuracy insurance plans at this time.</QESAlert>
      )}

      <div className="col-12">
        <QESMultiSelect
          containerClassName="mb-3"
          disabled={props.disabled}
          errorText="At least one role must be selected."
          label="Authorized Insurances"
          onChange={updateInsurances}
          options={insuranceOptions}
          required={false}
          testId="new-client__insurances"
          isValid={clientContext.validationObject["authorizedInsurances"]}
        />
      </div>
    </>
  );
}
